import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import Select from 'react-select';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../actions/alert';
import { crearPaquete } from '../../actions/clientes';
import { buscarPaquetesConfiguracion } from '../../actions/configuracion';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const NuevoPaquete = ({ paquete, reestablecerPaquete }) => {

    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.configuracion.paquetes);

    const [contratacionData, setContratacionData] = useState({
        id_cliente: null, 
        id_paquete: null, 
        total: null, 
        comision: null, 
        metodo: null
    });

    const [paqueteData, setPaqueteData] = useState(null);
    const [paquetesFilter, setPaquetesFilter] = useState([]);

    const [metodoData, setMetodoData] = useState(null);
    const metodosFilter = [
        { value: 0, label: 'Efectivo' },
        { value: 1, label: 'Tarjeta' },
        { value: 2, label: 'Transferencia' }
    ];

    const [paqueteModal, setPaqueteModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Agregar paquete */
    const handleAbrir = () => {
        if(paquete?.cliente){
            setContratacionData({
                ...contratacionData, 
                id_cliente: paquete.cliente
            });
        }

        dispatch(buscarPaquetesConfiguracion());
    }

    const handleSelectPaquete = (option) => {
        setPaqueteData(option);

        setContratacionData({
            ...contratacionData,
            id_paquete: option != null ? option.value : null, 
            total: option != null ? option.precio : null, 
            comision: option != null ? option.comision : null
        });
    }

    const handleSelectMetodo = (option) => {
        setMetodoData(option);

        setContratacionData({
            ...contratacionData,
            metodo: option != null ? option.value : null
        });
    }

    const handleProcesar = async () => {
        if(contratacionData.id_paquete && contratacionData.metodo != null){
            await setStatusProcesar(true);

            await dispatch(crearPaquete(contratacionData));

            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Todos los datos son requeridos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setContratacionData({
                id_cliente: null, 
                id_paquete: null, 
                total: null, 
                comision: null, 
                metodo: null
            });

            setPaqueteData(null);
            setMetodoData(null);

            reestablecerPaquete(null);
            setPaqueteModal(false);
        }
    }

    useEffect(() => {
        if(paquete?.cliente){
            setPaqueteModal(true);

            setContratacionData({
                ...contratacionData, 
                id_cliente: paquete.cliente, 
                total: paquete.total
            });
        }
    }, [paquete]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado?.length; i++) {
            options.push({ value: listado[i]._id, label: listado[i].nombre, precio: listado[i].precio, comision: listado[i].comision });
        }

        setPaquetesFilter(options);
    }, [listado]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .delete {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <Modal show={paqueteModal} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Nueva contratación de paquete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    id="paquete"
                                    name="paquete"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Paquete a adquirir"
                                    isClearable={true}
                                    options={paquetesFilter}
                                    value={paqueteData}
                                    onChange={(value) => handleSelectPaquete(value)}
                                    menuPortalTarget={document.body}
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-6 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <CurrencyInput
                                        id="total"
                                        name="total"
                                        className="form-control text-center"
                                        disabled={true}
                                        value={contratacionData.total || ''}
                                        decimalsLimit={2}
                                        groupSeparator=","
                                        decimalSeparator="."
                                    />
                                    <label htmlFor="total">Total a cobrar</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    id="metodo"
                                    name="metodo"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Método de pago"
                                    isClearable={true}
                                    options={metodosFilter}
                                    value={metodoData}
                                    onChange={(value) => handleSelectMetodo(value)}
                                    menuPortalTarget={document.body}
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>

                    {
                        statusProcesar ?
                            <button type="button" className="btn btn-success mr-3" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                        :
                            <button type="button" className="btn btn-success mr-3" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                    }
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default NuevoPaquete;